export default {
  title: 'Hurtige handlinger',
  send_push_notification: {
    label: 'Send push-notifikation',
    description: 'Opret en ny kampagne',
  },
  email_campaign: {
    label: 'E-mailkampagne',
    description: 'Send til abonnenter',
  },
  view_analytics: {
    label: 'Se analyser',
    description: 'Kampagneresultater',
  },
};
